import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import {
  Buttons,
  Spacer,
  boxContainer,
  questionnaireComponents,
  inputFields,
} from "..";

import "./styles.css";

const Location = ({ setPage }) => {
  const questionnaire = useSelector(
    (state) => state?.students?.student?.profileBuilder
  );

  const [state, setState] = useState({
    studyAboradPreference: null,
    regionInterest: null,
    regionPreference: null,
    countryPreference: [],
    urbanPreference: null,
  });

  useEffect(() => {
    setState({
      studyAboradPreference: questionnaire?.studyAboradPreference ?? null,
      regionInterest: questionnaire?.regionInterest ?? null,
      regionPreference: questionnaire?.regionPreference ?? null,
      countryPreference: questionnaire?.countryPreference ?? [],
      urbanPreference: questionnaire?.urbanPreference ?? null,
    });
  }, [questionnaire]);

  return (
    <boxContainer.LiteBoxContainer>
      <div className="section-input-title flex justify-between">
        <questionnaireComponents.QuestionnaireLabel text="1. How important is it for you to study abroad?" />
        <span className="text-[0.75em] text-grayText opacity-60">
          (least important 1, important 3, most important 5)
        </span>
      </div>
      <Spacer height="0.625em" />
      <questionnaireComponents.QuestionnaireCircleInput
        value={state?.studyAboradPreference}
      />
      <Spacer height="1.5em" />

      <questionnaireComponents.QuestionnaireLabel text="2. Do you know which country or region you're interested to study in?" />
      <Spacer height="0.625em" />
      <div className="pl-3">
        <inputFields.HorizontalRadio
          value={state.regionInterest}
          items={[
            { label: "Yes", value: "yes" },
            { label: "No", value: "no" },
          ]}
        />
      </div>
      <Spacer height="1.5em" />

      <questionnaireComponents.QuestionnaireLabel text="3. What region do you prefer?" />
      <Spacer height="0.3125em" />
      <div className="w-[31.25em]">
        <questionnaireComponents.QuestionnaireValueBox
          value={state?.regionPreference}
        />
      </div>
      <Spacer height="1.5em" />

      <questionnaireComponents.QuestionnaireLabel text="4. What are your top 3 countries of choice?" />
      <Spacer height="0.3125em" />
      <div className="w-[31.25em]">
        <questionnaireComponents.QuestionnaireValueBox
          value={state?.countryPreference?.map((item, index) => (
            <span
              className="p-2 bg-liteBoxBg border border-liteBoxBorder mr-2 rounded-lg"
              key={index}
            >
              {item}
            </span>
          ))}
        />
      </div>
      <Spacer height="1.5em" />
      <questionnaireComponents.QuestionnaireLabel
        text="5. How important is it for you to study in a university located in an
          urban area?"
      />
      <Spacer height="0.625em" />
      <questionnaireComponents.QuestionnaireCircleInput
        value={state?.urbanPreference}
      />

      <Spacer height="1.25em" />
      <div className="flex justify-end">
        <div className="w-[12.5em]">
          <Buttons.DefaultButton
            size="large"
            width="full"
            onClick={() => setPage("Financial")}
          >
            Next
          </Buttons.DefaultButton>
        </div>
      </div>
    </boxContainer.LiteBoxContainer>
  );
};

export default Location;
